import { render, staticRenderFns } from "./Month.vue?vue&type=template&id=5b5d4fba&scoped=true"
import script from "./Month.vue?vue&type=script&lang=js"
export * from "./Month.vue?vue&type=script&lang=js"
import style0 from "./Month.vue?vue&type=style&index=0&id=5b5d4fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d4fba",
  null
  
)

export default component.exports